import api from "@src/api/api";
import CompactPost from "@src/pages/news/posts/CompactPost";
import { Post } from "@src/utils/post";
import useDebounce from "@src/utils/useDebounce";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useEffect } from "react";

type Props = {
  userId: string;
  searchQuery: string;
};

type Response = {
  data: Post[];
  current_page: number;
  total_pages: number;
};
const PostLikes = (props: Props) => {
  const { userId } = props;
  const debouncedSearchQuery = useDebounce(props.searchQuery, 500);

  const list = useInfiniteQuery<Response>(
    [userId, debouncedSearchQuery],
    async ({ pageParam = 0 }) => {
      const { data } = await api.get(
        `/api/v1/feed?liked_by=${userId}&page=${pageParam}&q=${debouncedSearchQuery}`,
      );
      return data;
    },
    {
      getNextPageParam: lastPage => {
        const nextPage = lastPage.current_page + 1;
        return nextPage <= lastPage.total_pages ? nextPage : false;
      },
    },
  );

  const handleScroll = () => {
    const scrollElement = document.getElementsByTagName("main")[0];

    if (list.isFetchingNextPage || !list.hasNextPage) return;

    if (
      Math.abs(scrollElement.scrollHeight - scrollElement.scrollTop - scrollElement.clientHeight) <
      1000
    ) {
      list.fetchNextPage();
    }
  };

  useEffect(() => {
    const scrollElement = document.getElementsByTagName("main")[0];

    if (scrollElement === undefined) return;

    scrollElement.addEventListener("scroll", handleScroll);
    return () => scrollElement.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <div className="mt-2 grid grid-cols-2 gap-4 xl:grid-cols-5">
        {list.data &&
          list.data.pages.map(page =>
            page.data.map((item: Post) => (
              <CompactPost
                key={item.id}
                id={item.id}
                type={item.watch ? "video" : "text"}
                viewCount={item.view_count}
                likeCount={item.like_count}
                image={getMediaImage(item)}
              />
            )),
          )}
      </div>
    </>
  );
};

const getMediaImage = (post: Post) => {
  if (post.media && post.media[0]) {
    if (post.media[0].data_url === "image") return post.media[0].data_url;
    if (post.media[0].type === "video") return post.media[0].data_url + "/thumbnails/thumbnail.jpg";
  }
  if (post.link_preview && post.link_preview.image) {
    return post.link_preview.image + "/tile";
  }
  return "/images/default_header_profile.png";
};

export default PostLikes;
